import type { ReceiptTemplate } from '../schema';

export const lyftTemplate: ReceiptTemplate = {
  id: 'lyft',
  name: 'Lyft Receipt',
  brand: 'LYFT',
  description: 'Rideshare receipt template',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'lyft-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '/logos/lyft.png',
        logoData: '',
        logoWidth: 100,
        logoHeight: 50,
        businessName: '',
        businessNameFontSize: 24,
        addressLines: [
          'Ride Receipt',
        ],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'lyft-date',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'January 4, 2026 at 2:34 PM',
        fontSize: 12,
        showDivider: true,
        dividerStyle: 'spaces',
        isBold: false,
      },
    },
    {
      id: 'lyft-ride-type',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'left',
        message: 'Ride Type: Lyft\nDriver: James S.\nVehicle: Toyota Camry (Gray)',
        fontSize: 12,
        showDivider: true,
        dividerStyle: 'dashed',
        isBold: false,
      },
    },
    {
      id: 'lyft-trip',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'left',
        message: 'PICKUP\n1200 Dark Avenue, Monsterville\n2:34 PM\n\nDROPOFF\n500 Scare Floor Blvd, San Francisco\n3:12 PM',
        fontSize: 12,
        showDivider: true,
        dividerStyle: 'dashed',
        isBold: false,
      },
    },
    {
      id: 'lyft-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 40,
        labelAlignment: 'left',
        lines: [
          { id: 'lyft-base', label: 'Base Fare', value: '2.50', isBold: false, isLarge: false },
          { id: 'lyft-distance', label: 'Distance (12.4 mi)', value: '18.60', isBold: false, isLarge: false },
          { id: 'lyft-time', label: 'Time (38 min)', value: '7.60', isBold: false, isLarge: false },
          { id: 'lyft-fees', label: 'Service Fee', value: '3.27', isBold: false, isLarge: false },
          { id: 'lyft-subtotal', label: 'Subtotal', value: '31.97', isBold: false, isLarge: false },
          { id: 'lyft-tip', label: 'Tip', value: '5.00', isBold: false, isLarge: false },
          { id: 'lyft-total', label: 'Total', value: '36.97', isBold: true, isLarge: true },
        ],
        increaseTotalSize: true,
        totalSizeIncrease: 15,
        showDivider: true,
        dividerStyle: 'double',
      },
    },
    {
      id: 'lyft-payment',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'left',
        message: 'Payment Method:\nVisa ****4144',
        fontSize: 12,
        showDivider: true,
        dividerStyle: 'spaces',
        isBold: false,
      },
    },
    {
      id: 'lyft-id',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'Ride ID: 847291-ABCD-2026\n\nQuestions about your ride?\nhelp.lyft.com',
        fontSize: 10,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: false,
      },
    },
  ],
};

